module.exports = __webpack_public_path__ + "static/media/star.28fce329.png";